<template>
  <div>
    <rl :rd="routerData"></rl>
    <div class="about container">
      <h1 class="text-center">{{ data.title }}</h1>
      <div class="other">
        <span class="source"><img class="titleImg" src="../../assets/img/title.png" />
          {{ data.source }}</span
        ><span
          ><img class="titleImg" src="../../assets/img/time.png" />
          {{ data.create_time_text }}</span
        >
        <div class="sharelink">
          <!-- <a href="http://v.qq.com/vplus/nangua/videos"
            ><img src="../../assets/img/detail/c1.png"
          /></a> -->
          <a href="https://weibo.com/infzm"
            ><img src="../../assets/img/detail/c2.png"
          /></a>
          <!-- <a href="https://www.ximalaya.com/zhubo/194050845"
            ><img src="../../assets/img/detail/c3.png"
          /></a> -->
        </div>
      </div>
      <div class="banner" v-if="data.img"><img :src="data.img" /></div>
      <div class="content" v-html="data.content"></div>
      <div class="backhome"><router-link :to="{name:'home'}" tag="a">返回首页</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import header from "../public/header.vue";
import footer from "../public/footer.vue";
import rl from "../public/routerlink.vue";
export default {
  components: {
    rl
  },
  data() {
    return {
      data: "",
      routerData: [{ title: "动态资讯", link: "/action" }],
      get: {
        id: "",
        name: "dynamic"
      }
    };
  },
  created() {
    console.log(this.$route.params.id);
    this.get.id = this.$route.params.id;
    this.$http.get("/Index/index/data", { params: this.get }).then(res => {
       if(res.datas){
        this.data = res.datas;
        // this.routerData.push({'title':res.datas.title})
      }
    });
  }
};
</script>
<style lang="less" scoped>
h1 {
  border-bottom: 1px solid #bfbfbf;
  padding-bottom: 30px;
}

.other {
  margin: 30px 0;
  overflow: hidden;
  @lh:36px;
  @w:16px;
    line-height: @lh;
  .sharelink {
    float: right;
    img {
      width: @w+5;
      margin:0 5px;
    }
  }
  span {
    text-indent: 20px;
    margin: 0 10px;
    img {
      // float: left;
      margin-right:10px;
      width: @w;
      height: @w;
    }
  }
}
.banner{
  img{
    width:100%;
  }
}
.content {
  margin-top: 10px;

}
.about {
  justify-content: center;
  min-height: 500px;
  margin: 30px auto;
  /deep/ img {
    max-width: 100%;
  }
  /deep/  p{word-break:break-word;}
}
.vlbox {
  width: 400px;
  height: 400px;
  margin: 50px;
  border: 2px solid #bfbfbf;
  padding: 30px;
  h3 {
    height: 44px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(124, 124, 124, 1);
    opacity: 1;
    border-bottom: 1px dotted #bfbfbf;
  }
}
.backhome{
  text-align: center;
  clear: both;
  margin-top: 20px;
  a{
    padding:10px 20px;
    border:1px solid #EF5050;
    color:#EF5050;
    display: inline-block;
  }
}
@media (min-width:765px) {
  .content{
    padding:0 50px;
  }
}
@media (max-width:765px) {
.other{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .source{
    display: block;
    
    width: 100%;;
  }
  span{
    text-indent: 0;
  }
  .sharelink{
    float: none;
  }
}
}
</style>